import {
  Component,
  OnInit
} from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl
} from '@angular/forms';
import {
  MatDialog, MatDialogRef
} from '@angular/material/dialog';
import {
  MatSnackBar
} from '@angular/material/snack-bar';
import {
  Router
} from '@angular/router';
import {
  ApiService
} from 'src/app/services/api/api.service';
import {
  GlobalsService
} from 'src/app/services/globals/globals.service';

@Component({
  selector: 'app-confirm-delete-dialog',
  templateUrl: './confirm-delete-dialog.component.html',
  styleUrls: ['./confirm-delete-dialog.component.scss']
})
export class ConfirmDeleteDialogComponent implements OnInit {

  public breakpoint: number; // Breakpoint observer code
  public name: string = `Melodic-Opaque-Salamander`;

  public snr: string = `10000000935b2d16`;
  public cpuId: string = `abcdef1234567891`;
  public ethMac: string = `f5:5f:01:5d:95:82`;

  public ethMac1: string = `1`;


  public addThingsForm: FormGroup;
  wasFormChanged = false;

  options: FormGroup;
  macEthCntrl = new FormControl('');
  snrControl = new FormControl('');
  cpuControl = new FormControl('');


  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private api: ApiService,
    private _snackBar: MatSnackBar,
    public router: Router,
    private globals: GlobalsService,
    public dialogRef: MatDialogRef<ConfirmDeleteDialogComponent>,


  ) {

    this.options = fb.group({
      macEth: this.macEthCntrl,
      snr: this.snrControl,
      cpu: this.cpuControl
    });
  }



  public ngOnInit(): void {


    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
  }

  public onAddUser(): void {
  }

  confirmDelete() {
    this.dialogRef.close({event:'Delete'});
  }

  openDialog(): void {
    this.dialogRef.close({event:'Cancel'});


  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }




}
